// use the same indexing and names as RateType
export default {
  Yield: "Yield",
  IpsNetRate: "IpsNetRate",
  Per1000DifferenceMinForIps: "Per1000DifferenceMinForIps",
  GrossSalesRate: "GrossSalesRate",
  DealerNetRate: "DealerNetRate",
  IpsYieldAtDealerNetRate: "IpsYieldAtDealerNetRate"
};
